
export const fields = [
   { label: "Standard", type: "textarea",key:"RevisedStandardName",isDisabled:true, displayType:1 },
   { label: "Proposed Standard", type: "textarea",key:"Title",isDisabled:true, displayType:1 },
   { label: "Standard Type", type: "text",key:"StandardTypeId",isDisabled:true, displayType:1},
   { label: "WI Type", type: "text",key:"WorkItemTypeId",isDisabled:true, displayType:1 },
   { label: "Sponsoring Subcommittee", type: "text",key:"SubSectionCommitteeList",isDisabled:true, displayType:1 },
   { label: "Replaced By", type: "text",key:"ReplacedBy",isDisabled:true, displayType:1 },
   { label: "Technical Contact", type: "text",key:"MemberList",isDisabled:true, displayType:1 },
   { label: "Collaboration Area", type: "text",key:"IsOnlineCollaboration",isDisabled:true, displayType:1 },
   { label: "Emergency Response", type: "text",key:"IsEmergencyResponse",isDisabled:true, displayType:1 },
   { label: "Patented", type: "text",key:"IsPatented",isDisabled:true, displayType:1 },
   { label: "Emergency Description", type: "textarea",key:"EmergencyDescription",isDisabled:true, displayType:2 },
   { label: "Rationale", type: "textarea",key:"Rationale",isDisabled:true, displayType:2 },
   { label: "Scope", type: "textarea",key:"Scope",isDisabled:true, displayType:2 },
   { label: "Notify Others", type: "textarea",key:"OrganizationList",isDisabled:true, displayType:2 },
   { label: "Existing Standards", type: "textarea",key:"ExistingStandards",isDisabled:true, displayType:2 },
   { label: "Keywords", type: "textarea",key:"Keywords",isDisabled:true, displayType:2 },
   { label: "Authorize Date", type: "date",key:"AuthorizationDate",isDisabled:true, displayType:2.1 },
   { label: "Copyright", type: "text",key:"Copyright",isDisabled:true, displayType:2.1 },
   { label: "Copyright Acceptance Date", type: "date",key:"CopyrightAcceptanceDateTime",isDisabled:true, displayType:2.1 },
   { label: "Target Ballot Date", type: "date",key:"TargetBallotDate",isDisabled:true, displayType:2.1 },
   { label: "Completion Date From", type: "date",key:"CompletionDateFrom",isDisabled:true, displayType:2.1 },
   { label: "Completion Date To", type: "date",key:"CompletionDateTo",isDisabled:true , displayType:2.1},
   { label: "Creation Date", type: "date",key:"CreatedDate",isDisabled:true, displayType:2.1 },
   { label: "Modified Date", type: "date" ,key:"ModifiedDate",isDisabled:true, displayType:2.1},
   { label: "Reason for Delete", type: "textarea" ,key:"ReasonForDelete",isDisabled:true, displayType:2.1},
];

export const adminWIDetailFields = [
   { label: "Title", type: "textarea",key:"Title",isDisabled:true, displayType:1 },
   { label: "WI Type", type: "text",key:"WorkItemTypeId",isDisabled:true, displayType:1 },
   { label: "Sponsoring Subcommittee", type: "text",key:"AdminCommittee",isDisabled:true, displayType:1 },
   { label: "Technical Contact", type: "text",key:"MemberList",isDisabled:true, displayType:1 },
   { label: "Creation Date", type: "date",key:"CreatedDate",isDisabled:true, displayType:1 },
   { label: "Modified Date", type: "date" ,key:"ModifiedDate",isDisabled:true, displayType:1},
];
export const dtnDetailFields = [
   { label: "Committee", type: "hyperlink",key:"SubCommitteeName",isDisabled:true ,row :3 },
   { label: "Work Item", type: "hyperlink",key:"WorkItemTrackingNumber",isDisabled:true,row :3},
   { label: "", type: "",key:"",isDisabled:true,row :6},
   { label: "Ballot Action", type: "text",key:"DraftActionName",isDisabled:true,row :3},
   { label: "Standard Type", type: "text",key:"DocumentType",isDisabled:true,row :3 },
   { label: "Title", type: "textarea",key:"Title",isDisabled:true,row:6 },
   { label: "Draft Title Change ", type: "text",key:"DraftTitleChange",isDisabled:true,row:3 },
   { label: "Replacement Desig.", type: "hyperlink",key:"ReplacementDesignations",isDisabled:true,row:3 },
   { label: "Standard Format", type: "text",key:"StandardFormat",isDisabled:true,row:3 },
   { label: "Companion Desig.", type: "text",key:"CompanionDesignation",isDisabled:true,row:3 },
   { label: "Dependency DTN", type: "hyperlink",key:"DependencyDTN",isDisabled:true,row:3 },
   { label: "Dep WI Track. No.", type: "text",key:"DependencyWITrackingNo",isDisabled:true,row:3},
   { label: "Dependency Status", type: "text",key:"DependencyStatus",isDisabled:true,row:3 },
   { label: "Comment", type: "textarea",key:"DraftComment",isDisabled:true,row:12 },
   { label: "DTN Creation Date", type: "date",key:"CreatedDate",isDisabled:true,row:3 },
   { label: "Initial Date", type: "date",key:"InitialDate",isDisabled:true,row:3},
   { label: "Modified Date", type: "date",key:"ModifiedDate",isDisabled:true,row:3 },
];

export const dtnDetailTcnFields = [
   { label: "Account", type: "text",key:"TechnicalContactAccountNumber",isDisabled:true ,row :3 },
   { label: "Full Name", type: "text",key:"TechnicalContactName",isDisabled:true,row :3},
   { label: "Phone", type: "text",key:"TechnicalContactPhone",isDisabled:true,row :3},
   { label: "Email", type: "text",key:"TechnicalContactEmail",isDisabled:true,row :3},

];
export const WorkItemStatusList = [
    { key: 1, text: 'Proposed', value: 1 }
 ]
 
 export const WorkItemTypeList = [
    { key: 1, text: 'New Standard', value: 1 },
    { key: 2, text: 'Revision', value: 2 },
    { key: 3, text: 'Reapproval', value: 3 },
    { key: 4, text: 'Withdrawal', value: 4 },
    { key: 5, text: 'Reinstatement', value: 5 },
    { key: 6, text: 'Reapproval with Editorial Change', value: 6 },
    { key: 7, text: 'Withdrawal With Replacement', value: 7 },
    { key: 8, text: 'Administrative', value: 8 }
 ]
 
 export const WorkItemType = {
    NewStandard: 1,
    Revision: 2,
    Reapproval: 3,
    Withdrawal: 4,
    Reinstatement: 5,
    ReapprovalWithEditorialChange: 6,
    WithdrawalWithReplacement: 7,
    Administrative:8
 }
 
 export const YesNoOptions = [
    { key: 1, text: 'Yes', value: true },
    { key: 2, text: 'No', value: false }
 ]
 export const CompletionIntervalList = [
    { Id: 1, Interval: '3 - 6 months' },
    { Id: 2, Interval: '6 - 12 months' },
    { Id: 3, Interval: '12 - 18 months' },
    { Id: 4, Interval: '18 - 24 months' }
 ]
 export const CollabApiFailureActionEnum = {
   Update: 1,
   Delete: 2,
   Restore: 3
}
export const AuditLogTypeEnum = {
   Add: 1,
   Edit: 2,
   Delete: 3,
   Recover: 4,
   InactiveCommittee: 5,
   InactiveTechnicalContact: 6,
   Suppressed: 7,
   PermanentDeleted: 8,
   collabEditApiFailed: 9,
   collabDeleteApiFailed: 10,
   collabRecoverApiFailed: 11
}
export const draftBallotHistoryHeaderField = [
   {
       "HeaderId": 19,
       "HeaderName": "Original Ballot Item Number",
       "IsDefaultSelected": true,
       "IsSelected": true
   },
   {
       "HeaderId": 20,
       "HeaderName": "Ballot (SN Review)",
       "IsDefaultSelected": true,
       "IsSelected": true
   },
   {
       "HeaderId": 24,
       "HeaderName": "Item Number",
       "IsDefaultSelected": true ,
       "IsSelected": true
   },
   {
       "HeaderId": 21,
       "HeaderName": "Concurrent",
       "IsDefaultSelected": true ,
       "IsSelected": true
   },
   {
       "HeaderId": 22,
       "HeaderName": "Item Description",
       "IsDefaultSelected": true ,
       "IsSelected": true
   },
   {
       "HeaderId": 23,
       "HeaderName": "Item Status",
       "IsDefaultSelected": true ,
       "IsSelected": true  
   },
   {
       "HeaderId": 25,
       "HeaderName": "Negative",
       "IsDefaultSelected": true ,
       "IsSelected": true
   },
   {
      "HeaderId": 25,
      "HeaderName": "Resolved",
      "IsDefaultSelected": true  ,
      "IsSelected": true
  },
  {
   "HeaderId": 25,
   "HeaderName": "Approved",
   "IsDefaultSelected": true  ,
   "IsSelected": true
}
]
 